import { OonaPost } from '../../../../../../models/oona-post';
import { listOrderedPlatforms } from '../../../../../app.constants';
import { OonaReportComponent } from '../oona-report.component';
import { PdfExportService } from '../../../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../../../services/user.service';
var OonaReportItemComponent = /** @class */ (function () {
    function OonaReportItemComponent(pdfService, _userService) {
        this.pdfService = pdfService;
        this._userService = _userService;
    }
    OonaReportItemComponent.prototype.ngOnInit = function () {
    };
    OonaReportItemComponent.prototype.onLoadedImage = function () {
        this.pdfService.updateNumberImageLoaded("" + OonaReportComponent.COMPONENT_NAME + this.pageOrderNo);
    };
    OonaReportItemComponent.prototype.platformName = function (platformId) {
        var platform = listOrderedPlatforms[platformId - 1];
        return platform ? platform.name.toLowerCase() : null;
    };
    Object.defineProperty(OonaReportItemComponent.prototype, "reachIndex", {
        get: function () {
            return Math.abs(this.post.reachIndex);
        },
        enumerable: true,
        configurable: true
    });
    OonaReportItemComponent.prototype.getIndexStatus = function (value) {
        return value >= 100 ? 'asc' : 'desc';
    };
    Object.defineProperty(OonaReportItemComponent.prototype, "interactionIndex", {
        get: function () {
            return Math.abs(this.post.interactionIndex);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OonaReportItemComponent.prototype, "activeAccount", {
        get: function () {
            return this._userService.getCompanyId();
        },
        enumerable: true,
        configurable: true
    });
    return OonaReportItemComponent;
}());
export { OonaReportItemComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/oona-report/oona-report-item/oona-report-item.component.ts.pre-build-optimizer.js